import { useState, useEffect, useContext } from "react";
import { ThemeContext, DeleteModalContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select"
import * as LicenceMasterService from "../../services/licenceMasterService";
import * as FeedModulesService from "../../services/feedModulesService";
import { Loader } from "../../utils/loader";
import * as PackageMasterServices from '../../services/packageMasterServices';
import NoDataError from "../../components/NoDataError";
import moment from "moment";

const licenseMasterAddModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

const userUpdateModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

const packageListModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

function LicenceMaster(props) {
   let toast = useContext(ThemeContext);
   let deleteData = useContext(DeleteModalContext);
   const [licenseMasterAddModalShow, setLicenseMasterAddModalShow] = useState(false);
   const [userUpdateModalShow, setUserUpdateModalShow] = useState(false);
   const [licenseCreationObj, setLicenseCreationObj] = useState({});
   const [selectedFeedModuleId, setSelectedFeedModuleId] = useState(null);
   const [feedModuleList, setFeedModuleList] = useState([]);
   const [operatorList, setOperatorList] = useState([]);
   const [operatorEndDateObj, setOperatorEndDateObj] = useState({});
   const [userDetailObj, setUserDetailObj] = useState({});
   const [isWhitelabel, setIsWhitelabel] = useState(false)
   const [isEdit, setIsEdit] = useState(false);
   const [selectedLicenceStatus, setSelectedLicenceStatus] = useState("");
   const [loader, setLoader] = useState(false);
   const [selectedArr, setSelectedArr] = useState([]);
   const [groupingLicenceMasterList, setGroupingLicenceMasterList] = useState({});
   const [filterGroupingLicenceMasterList, setFilterGroupingLicenceMasterList] = useState({});
   const [showPackagesListModal, setShowPackagesListModal] = useState(false);
   const [packagesList, setPackagesList] = useState([]);
   const [isLoader, setIsLoader] = useState(false);
   const [licenceDetial, setLicenceDetail] = useState({});
   const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
   const [packageDisableSubmitBtn, setPackageDisableSubmitBtn] = useState(false);
   const [selectedPackagesIds, setSelectedPackagesIds] = useState([]);
   const [clientWebURL, setClientWebURL] = useState('');

   const licenceCreationDefaultObj = {
      "whiteLabel": false,
      "operatorId": "",
      "serverDisplayName": "",
      "serverIP": "",
      "primaryDomain": "",
      "secondaryDomain": "",
      "accessDomain": "",
      "companyName": "",
      "personName": "",
      "referenceName": "",
      "companyAddress": "",
      "companyCity": "",
      "companyState": "",
      "contactNo": "",
      "contactEmail": "",
      "contactSkype": "",
      "webSite": "",
      "companyDescription": "",
      "allowedClientWeb": false,
      "authKey": "",
      "licenseStartDate": new Date(Date.now()).toISOString().split("T")[0],
      "licenseEndDate": "",
      "licenseSharing": 0,
      "symbolsLimit": 0,
      "groupsLimit": 0,
      "dealersLimit": 0,
      "clientsLimit": 0,
      "commissionProfileslimit": 0,
      "balanceCreditLimit": 0,
      "licenseDBConnection": "",
      "licenseDescription": "",
      "licenseLogo": "",
      "licenseStatus": true,
      "feedModuleId": [],
      "userName": "",
      "name": "",
      "userPassword": "",
      "userDescription": "",
      "userStatus": true,
      "allowedOnlinePayment": true,
      "licenseType": "B2B"
   }

   const licenceMasterErrorObj = {
      primaryDomainError: false,
      companyNameError: false,
      licenseStartDateError: false,
      licenseEndDateError: false,
      licenseSharingError: false,
      symbolsLimitError: false,
      groupsLimitError: false,
      dealersLimtError: false,
      clientsLimitError: false,
      profilesLimitError: false,
      balanceCreditLimitError: false,
   }

   const [errors, setErrors] = useState(licenceMasterErrorObj);

   useEffect(() => {
      getLicenses();
      getPackages();
   }, [])

   useEffect(() => {
      if (!isEdit) {
         let lobj = { ...licenceCreationDefaultObj }
         lobj["whiteLabel"] = isWhitelabel
         setLicenseCreationObj({ ...lobj })
      }
   }, [isWhitelabel]);

   const getFeedModule = (edit, licenseObj) => {
      FeedModulesService.getAllFeedModules().then((res) => {
         if (res.isSuccess) {
            let modules = []
            let setDefaultModule = []
            if (edit) {
               !!res && !!res.data && res.data.forEach(item => {
                  modules.push({ value: item.feedModuleId, label: item.feedModuleDisplayName })
                  if (!!licenseObj.feedModuleId && licenseObj.feedModuleId.length > 0 && licenseObj.feedModuleId.includes(item.feedModuleId)) {
                     setDefaultModule.push({ value: item.feedModuleId, label: item.feedModuleDisplayName })
                  }
               });
            } else {
               !!res && !!res.data && res.data.forEach(item => {
                  modules.push({ value: item.feedModuleId, label: item.feedModuleDisplayName })
               });
            }
            setFeedModuleList([...modules])
            setSelectedFeedModuleId([...setDefaultModule])
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const getLicenses = () => {
      setLoader(true);
      LicenceMasterService.getAllLicenses().then((res) => {
         setLoader(false);
         if (res.isSuccess) {
            const groupLicenceMaster = res?.data?.reduce((groups, item) => {
               const opcode = item.operatorId;
               if (!groups[opcode]) {
                  groups[opcode] = { itm: [], displayName: null };
               }
               groups[opcode].itm.push(item);
               if (!item?.parentCompanyName) {
                  groups[opcode].displayName = `${item?.operatorId} - ${item?.companyName} (${item?.primaryDomain})`
               }
               return groups;
            }, {})
            setGroupingLicenceMasterList(groupLicenceMaster);
            setFilterGroupingLicenceMasterList(groupLicenceMaster);
            setLoader(false);
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message);
            setLoader(false);
         }
      }).catch(e => {
         setLoader(false);
      })
   }

   const getOperatorsForWhitelabel = () => {
      LicenceMasterService.getOperators().then((res) => {
         if (res.isSuccess) {
            setOperatorList(!!res && !!res.data && res.data)
            let opEndDateObj = {}
            !!res && !!res.data && res.data.forEach(item => {
               opEndDateObj[item.operatorId] = item.licenseEndDate.split("T")[0]
            })
            setOperatorEndDateObj({ ...opEndDateObj })
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const userDetailById = (operatorId, licenseId) => {
      LicenceMasterService.getuserDetailById(operatorId, licenseId).then((res) => {
         if (res.isSuccess) {
            if (!!res.data && Object.keys(res.data).length > 0) {
               let data = res.data
               data["userStatusDefault"] = data["userStatus"]
               data["userPassword"] = ""

               setUserDetailObj({ ...data })
            }
            openUserUpdateModalShow()
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const onSyncModules = (id) => {
      deleteData({ openDeleteModal: true, customMessage: 'You want to sync data!', callBackFunction: onSyncModulesFn, deleteModalItem: id, isNotValid: null, type: 'sync' })
   }

   const onSyncModulesFn = (id) => {
      let isNotValid = true;
      LicenceMasterService.syncModules(id).then((res) => {
         isNotValid = false;
         if (res.isSuccess) {
            toast.success(res.data.message);
            deleteData({ openDeleteModal: false, customMessage: "", callBackFunction: null, deleteModalItem: null, isNotValid: isNotValid, type: null })
         } else {
            deleteData({ openDeleteModal: false, customMessage: "", callBackFunction: null, deleteModalItem: null, isNotValid: isNotValid, type: null })
         }
      })
   }

   const onSyncLicenceVersion = (id) => {
      deleteData({ openDeleteModal: true, customMessage: 'You want to sync Licence Version!', callBackFunction: onSyncLicenceVersionFn, deleteModalItem: id, isNotValid: null, type: 'sync' })
   }

   const onSyncLicenceVersionFn = (id) => {
      let isNotValid = true;
      LicenceMasterService.syncLicenceVersion(id).then((res) => {
         if (res.isSuccess) {
            isNotValid = false;
            toast.success(res.data.message);
            deleteData({ openDeleteModal: false, customMessage: '', callBackFunction: null, deleteModalItem: null, isNotValid: isNotValid, type: null })
         } else {
            deleteData({ openDeleteModal: false, customMessage: '', callBackFunction: null, deleteModalItem: null, isNotValid: isNotValid, type: null })
         }
      })
   }

   const onChangeUserDetail = (event) => {
      let name = event.target.name
      let value = event.target.value
      let changeuserDetailObj = { ...userDetailObj }

      if (name === "userStatus") {
         value = (value === 'true')
      }
      changeuserDetailObj[name] = value
      setUserDetailObj({ ...changeuserDetailObj })
   }

   const onUpdateUserDetail = (activityName) => {
      let body = { ...userDetailObj }
      body["operatorId"] = userDetailObj["operatorId"]
      body["licenseId"] = userDetailObj["licenseId"]

      if (activityName === "userPassword") {
         body["userPassword"] = userDetailObj["userPassword"]

         LicenceMasterService.updateUserPassword({ ...body }).then((res) => {
            if (res.isSuccess) {
               toast.success(!!res && !!res.successMessage && res.successMessage)
               closeUserUpdateModalShow()
               setUserDetailObj({})
            } else {
               toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
            }
         })
      }
      else if (activityName === "userStatus") {
         body["userStatus"] = userDetailObj["userStatus"]

         LicenceMasterService.updateUserStatus(body).then((res) => {
            if (res.isSuccess) {
               toast.success(!!res && !!res.successMessage && res.successMessage)
               closeUserUpdateModalShow()
               setUserDetailObj({})
            } else {
               toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
            }
         })
      }
   }

   const licenseById = (licenseId) => {
      setIsEdit(true)
      LicenceMasterService.getLicenseById(licenseId).then((res) => {
         if (res.isSuccess) {
            setIsWhitelabel(res.data.whiteLabel)
            let data = { ...res.data }
            data.licenseStartDate = data.licenseStartDate.split("T")[0]
            data.licenseEndDate = data.licenseEndDate.split("T")[0]
            setLicenseCreationObj({ ...data })
            getFeedModule(true, { ...data })
            editLicenseMasterAddModal()
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const onSubmitLicense = () => {
      let body = { ...licenseCreationObj }
      body.feedModuleId = []
      if (!!selectedFeedModuleId && selectedFeedModuleId.length > 0) {
         selectedFeedModuleId.forEach(item => {
            body.feedModuleId.push(item.value)
         })
      }
      let isValid = true;
      if (!isEdit) {
         let licenceError = { ...licenceMasterErrorObj };
         if (!licenseCreationObj["primaryDomain"] || licenseCreationObj["primaryDomain"] === '') {
            licenceError.primaryDomainError = true;
            isValid = false;
         }
         if (!licenseCreationObj['companyName'] || licenseCreationObj['companyName'] === '') {
            licenceError.companyNameError = true;
            isValid = false;
         }
         if (!licenseCreationObj['licenseStartDate'] || licenseCreationObj['licenseStartDate'] === '') {
            licenceError.licenseStartDateError = true;
            isValid = false;
         }
         if (!licenseCreationObj['licenseEndDate'] || licenseCreationObj['licenseEndDate'] === '') {
            licenceError.licenseEndDateError = true;
            isValid = false;
         }
         if (licenseCreationObj['licenseSharing'] === '' || licenseCreationObj['licenseSharing'] < 0) {
            licenceError.licenseSharingError = true;
            isValid = false;
         }
         if (licenseCreationObj['symbolsLimit'] === '' || licenseCreationObj['symbolsLimit'] < 0) {
            licenceError.symbolsLimitError = true;
            isValid = false;
         }
         if (licenseCreationObj['groupsLimit'] === '' || licenseCreationObj['groupsLimit'] < 0) {
            licenceError.groupsLimitError = true;
            isValid = false;
         }
         if (licenseCreationObj['dealersLimit'] === '' || licenseCreationObj['dealersLimit'] < 0) {
            licenceError.dealersLimtError = true;
            isValid = false;
         }
         if (licenseCreationObj['clientsLimit'] === '' || licenseCreationObj['clientsLimit'] < 0) {
            licenceError.clientsLimitError = true;
            isValid = false;
         }
         if (licenseCreationObj['commissionProfileslimit'] === '' || licenseCreationObj['commissionProfileslimit'] < 0) {
            licenceError.profilesLimitError = true;
            isValid = false;
         }
         if (licenseCreationObj['balanceCreditLimit'] === '' || licenseCreationObj['balanceCreditLimit'] < 0) {
            licenceError.balanceCreditLimitError = true;
            isValid = false;
         }
         setErrors(licenceError)
      }

      body.licenseStartDate = body.licenseStartDate + "T00:00:00"
      body.licenseEndDate = body.licenseEndDate + "T00:00:00"

      if (!!isEdit) {
         body = {
            "licenseId": licenseCreationObj['licenseId'],
            "operatorId": licenseCreationObj['operatorId'],
            "serverDisplayName": licenseCreationObj['serverDisplayName'],
            "serverIP": licenseCreationObj['serverIP'],
            "primaryDomain": licenseCreationObj['primaryDomain'],
            "secondaryDomain": licenseCreationObj['secondaryDomain'],
            "accessDomain": licenseCreationObj['accessDomain'],
            "companyName": licenseCreationObj['companyName'],
            "personName": licenseCreationObj['personName'],
            "referenceName": licenseCreationObj['referenceName'],
            "companyAddress": licenseCreationObj['companyAddress'],
            "companyCity": licenseCreationObj['companyCity'],
            "companyState": licenseCreationObj['companyState'],
            "contactNo": licenseCreationObj['contactNo'],
            "contactEmail": licenseCreationObj['contactEmail'],
            "webSite": licenseCreationObj['webSite'],
            "contactSkype": licenseCreationObj['contactSkype'],
            "companyDescription": licenseCreationObj['companyDescription'],
            "allowedClientWeb": licenseCreationObj['allowedClientWeb'],
            "licenseStartDate": licenseCreationObj['licenseStartDate'],
            "licenseEndDate": licenseCreationObj['licenseEndDate'],
            "licenseSharing": licenseCreationObj['licenseSharing'],
            "balanceCreditLimit": licenseCreationObj['balanceCreditLimit'],
            "symbolsLimit": licenseCreationObj['symbolsLimit'],
            "groupsLimit": licenseCreationObj['groupsLimit'],
            "dealersLimit": licenseCreationObj['dealersLimit'],
            "clientsLimit": licenseCreationObj['clientsLimit'],
            "commissionProfileslimit": licenseCreationObj['commissionProfileslimit'],
            "licenseDBConnection": licenseCreationObj['licenseDBConnection'],
            "licenseLogo": licenseCreationObj['licenseLogo'],
            "licenseDescription": licenseCreationObj['licenseDescription'],
            "licenseStatus": licenseCreationObj['licenseStatus'],
            "allowedOnlinePayment": licenseCreationObj["allowedOnlinePayment"],
            "licenseType": licenseCreationObj["licenseType"],
            "feedModuleId": body?.feedModuleId
         };

         setDisableSubmitBtn(true);
         LicenceMasterService.updateLicence(body).then((res) => {
            if (res.isSuccess) {
               toast.success(!!res && !!res.successMessage && res.successMessage)
               closeLicenseMasterAddModal()
               getLicenses()
               setLicenseCreationObj({ ...licenceCreationDefaultObj })
               setIsEdit(false)
               setIsWhitelabel(false)
            } else {
               toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
            }
            setDisableSubmitBtn(false);
         }).catch(e => {
            console.error(e);
            setDisableSubmitBtn(false);
         })
      }
      else {
         if (isValid) {
            setDisableSubmitBtn(true);
            LicenceMasterService.createLicence({ ...body }).then((res) => {
               if (res.isSuccess) {
                  toast.success(!!res && !!res.successMessage && res.successMessage)
                  closeLicenseMasterAddModal()
                  getLicenses()
                  setLicenseCreationObj({ ...licenceCreationDefaultObj })
                  setIsEdit(false)
                  setIsWhitelabel(false)
               } else {
                  toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
               }
               setDisableSubmitBtn(false);
            }).catch(e => {
               console.error(e);
               setDisableSubmitBtn(false);
            })
         }
      }
   }

   const onChange = (event) => {
      let name = event.target.name
      let value = event.target.value
      let changeLicenseObj = { ...licenseCreationObj }

      if (name === "licenseStatus") {
         value = (value === 'true')
      } else if (name === "userStatus") {
         value = (value === 'true')
      } else if (name === "whiteLabel") {
         value = (value === 'true')
         setIsWhitelabel(value)
         if (!!value && !isEdit) {
            getOperatorsForWhitelabel()
         }
      } else if (name === "operatorId" && !!isWhitelabel) {
         changeLicenseObj["licenseEndDate"] = operatorEndDateObj[value]
      } else if (name === "allowedClientWeb") {
         value = (value === 'true')
      } else if (name === "allowedOnlinePayment") {
         value = (value === 'true')
      }

      changeLicenseObj[name] = value
      setLicenseCreationObj({ ...changeLicenseObj })
   }

   const restrictValueonType = (e) => {
      ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
   }

   const onImageChoose = (event) => {
      if (event.target.files[0].size < 51200) {
         let file = event.target.files[0];
         let name = event.target.name
         let value = event.target.value;

         if (["jpg", "jpeg", "png", "gif"].includes(value.split(".")[value.split(".").length - 1])) {

            let reader = new FileReader();

            reader.onloadend = () => {
               let changeLicenseObj = { ...licenseCreationObj }
               changeLicenseObj[name] = reader.result
               setLicenseCreationObj({ ...changeLicenseObj })
            }
            reader.readAsDataURL(file);

         } else {
            toast.error("Only Image file formats - jpg, jpeg, png, gif supported !!!")
            document.getElementById("licenseLogo").value = ""
         }

      } else {
         toast.error("Logo Size must be lower than 50 KB !!!")
         document.getElementById("licenseLogo").value = ""
      }
   }

   const statusOfTestConnection = () => {
      if (!licenseCreationObj["operatorId"]) {
         return false;
      }
      LicenceMasterService.getConnectionStatus(licenseCreationObj["operatorId"]).then((res) => {
         if (res.isSuccess) {
            if (res.data.isSuccess === true) {
               toast.success(res.data.message)
            } else if (res.data.isSuccess === false) {
               toast.error(res.data.message);
            }
         } else {
            toast.error(res.exception.message);
         }
      })
   }

   useEffect(() => {
      if (!!selectedLicenceStatus) {
         const filteredLicenceMasterList = Object.keys(groupingLicenceMasterList)
            .filter(key => selectedLicenceStatus.includes(key))
            .reduce((result, key) => {
               result[key] = groupingLicenceMasterList[key];
               return result;
            }, {});
         setFilterGroupingLicenceMasterList(filteredLicenceMasterList);
      } else {
         setFilterGroupingLicenceMasterList({ ...groupingLicenceMasterList });
      }
   }, [selectedLicenceStatus])


   const openLicenseMasterAddModal = () => {
      setLicenseCreationObj({ ...licenceCreationDefaultObj });
      setLicenseMasterAddModalShow(true);
      getFeedModule(false, {})
      setOperatorList([])
      setOperatorEndDateObj({})
   }

   const editLicenseMasterAddModal = () => {
      setLicenseMasterAddModalShow(true);
      setOperatorList([])
      setOperatorEndDateObj({})
   }

   const closeLicenseMasterAddModal = () => {
      setLicenseCreationObj({ ...licenceCreationDefaultObj });
      setLicenseMasterAddModalShow(false);
      setIsEdit(false);
      setIsWhitelabel(false);
      setFeedModuleList([]);
      setSelectedFeedModuleId([]);
      setOperatorList([]);
      setOperatorEndDateObj({});
      setDisableSubmitBtn(false);
      setPackageDisableSubmitBtn(false);
      setErrors(licenceMasterErrorObj);
   }

   const openUserUpdateModalShow = () => {
      setUserUpdateModalShow(true)
   }

   const closeUserUpdateModalShow = () => {
      setUserUpdateModalShow(false);
   }

   const onSelectionRow = (item) => {
      for (const operatorId in filterGroupingLicenceMasterList) {
         const operatorItems = filterGroupingLicenceMasterList[operatorId];
         const selectedRow = operatorItems?.itm?.map((elem) => { return elem.licenseId }).indexOf(item.licenseId);
         if (selectedRow !== -1) {
            setSelectedArr([operatorItems[selectedRow]]);
         }
      }
   }

   const checkItem = (item) => {
      const checkData = !!selectedArr && selectedArr.some((val) => val?.licenseId === item?.licenseId);
      return checkData;
   }

   const copyToClipboard = (key) => {
      navigator.clipboard.writeText(key);
      toast.info('Url copied successfully');
   }

   const getPackages = () => {
      setIsLoader(true);
      PackageMasterServices.getAllPackages().then((res) => {
         setIsLoader(false);
         if (res.isSuccess) {
            setPackagesList(res.data);
         } else {
            setIsLoader(false);
         }
      }).catch(e => {
         setIsLoader(false);
      })
   }

   const openPackagesListModal = (item) => {
      setLicenceDetail(item);
      PackageMasterServices.getPackagesLicenceById(item?.licenseId).then((res) => {
         if (res.isSuccess) {
            let getByIdList = [];
            res.data.forEach((item) => {
               getByIdList.push(item?.packageId)
            })
            setSelectedPackagesIds([...getByIdList]);
            setShowPackagesListModal(true);
         }
      })
   }

   const closePackageListModal = () => {
      setShowPackagesListModal(false);
   }

   const selectedOnChangeFn = (isChecked, ids) => {
      setSelectedPackagesIds((prev) => (isChecked ? [...prev, ids] : prev.filter((id) => id !== ids)));
   }

   const onSubmitPackagesList = () => {
      let body = { ...licenceDetial };
      let data = {
         "operatorId": body?.operatorId,
         "licenseId": body?.licenseId,
         "packageId": ""
      }
      if (!!selectedPackagesIds && selectedPackagesIds.length > 0) {
         data.packageId = selectedPackagesIds.join(',');
      }
      setPackageDisableSubmitBtn(true);
      LicenceMasterService.submitLicencePackages(data).then((res) => {
         setPackageDisableSubmitBtn(false);
         if (res.isSuccess) {
            toast.success(res?.successMessage);
            setShowPackagesListModal(false);
         } else {
            toast.error(res?.exception?.message);
            setPackageDisableSubmitBtn(false);
         }
      }).catch(e => {
         setPackageDisableSubmitBtn(false);
      })
   }

   return (
      <>
         <div id="tabs">
            {loader && <Loader />}
            {isLoader && <Loader />}
            <div className="maintitle-box">
               <div className="w-50 d-inline-block">
                  <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/licence-valid.svg"} alt="" />Licence Master</h2>
                  {/* <p className="maintitle-text ">&nbsp;</p> */}
               </div>
               {/* <div className="w-50 d-inline-block">
                  <select className="form-select inputborder w-100 font11" value={selectedLicenceStatus} onChange={(e) => { setSelectedLicenceStatus(e.target.value) }}>
                     <option value="">All</option>
                     <option value="Whitelabel">Whitelabel</option>
                     <option value="Licence">Licence</option>
                  </select>
               </div> */}
               <div className="align-center d-flex d-inline-block justify-content-end w-50">
                  <div className="d-inline-block mr-2"><i id="licenceMasterRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
                     onClick={() => { getLicenses(); setSelectedLicenceStatus("") }}></i>
                  </div>
                  <div className="d-inline-block float-end w-200 mr-2">
                     <select className="form-select inputborder w-100 font11" value={selectedLicenceStatus} onChange={(e) => { setSelectedLicenceStatus(e.target.value) }}>
                        <option value="">All</option>
                        {Object.entries(groupingLicenceMasterList).map(([key, item]) => {
                           return (
                              <option className={`${!item?.itm[0]?.licenseStatus && "dropdown-bg-color"}`} key={key} value={key}>{item?.displayName}</option>
                           )
                        })}
                     </select>
                  </div>
                  <div className="float-end ">
                     <button className="addnewbtn mb-0" onClick={() => { openLicenseMasterAddModal() }}>
                        <i className="fa-solid fa-circle-plus mr-2"></i>Add
                     </button>
                  </div>
               </div>
            </div>
            {Object.keys(filterGroupingLicenceMasterList).length > 0 ? Object.entries(filterGroupingLicenceMasterList).map(([opercode, groups]) => ({ opercode, groups })).sort((a, b) => a.opercode.localeCompare(b.opercode)).map(({ opercode, groups }) => {
               return (
                  <>
                     <div className="thead-fixed" key={groups.displayName}>
                        <div className='font-13 font-bold ml-2'>{groups?.displayName}</div>
                        <table className="table table-bordered w-100 mb-30">
                           <thead>
                              <tr className="thead-dard-bg">
                                 <th className="srn-width">Sr</th>
                                 <th className="srn-width">Parent Company</th>
                                 <th className="lic-op">Op Code</th>
                                 <th className="lic-whitelable">Whitelabel</th>
                                 <th className="">Company Name</th>
                                 <th className="lic-server">Server Name</th>
                                 <th className="lic-domain">Domain</th>
                                 <th className="lic-sharing">Sharing</th>
                                 <th className="lic-date">Start Date</th>
                                 <th className="lic-date">End Date</th>
                                 <th className="lic-created">Lic Created</th>
                                 <th className="lic-admin-created">Admin Created</th>
                                 <th className="lic-status">Status</th>
                                 <th className="lic-date">Action</th>
                              </tr>
                           </thead>
                           <tbody>
                              {!!groups && groups?.itm?.sort((a, b) => { return b.licenseStatus - a.licenseStatus }).map((item, i) => {
                                 return (
                                    <tr key={`${item?.licenseId}_${i}`} className={`${!item.licenseStatus ? "text-pink" : (!item.whiteLabel ? 'text-green' : '')} ${checkItem(item) ? 'selected-tr' : ''}`} onClick={() => onSelectionRow(item)} onDoubleClick={() => licenseById(item.licenseId)}>
                                       <td className="">{i + 1}</td>
                                       <td className="">{!!item.parentCompanyName ? item.parentCompanyName : "-"}</td>
                                       <td className="">{item.operatorId}</td>
                                       <td className="">{item.whiteLabel ? "Yes" : "No"}</td>
                                       <td className="">{item.companyName}</td>
                                       <td className="">{item.serverDisplayName}</td>
                                       <td className="">{item.primaryDomain}</td>
                                       <td className="">{item.licenseSharing}</td>
                                       <td className="">{moment(new Date(item.licenseStartDate)).format("DD/MM/YYYY")}</td>
                                       <td className="">{moment(new Date(item.licenseEndDate)).format("DD/MM/YYYY")}</td>
                                       <td className="">{item.licenseCreated ? "Yes" : "No"}</td>
                                       <td className="">{item.adminCreated ? "Yes" : "No"}</td>
                                       <td className="">{item.licenseStatus ? "Active" : "Inactive"}</td>
                                       <td className="">
                                          <i className="fa fa-edit" title="Edit Licence" onClick={() => { licenseById(item.licenseId) }}></i>
                                          {!item.whiteLabel && <i title="Reset Admin" className="fa fa-user ml-2" onClick={() => { userDetailById(item.operatorId, item.licenseId) }}></i>}
                                          {!item.whiteLabel && <img title="Sync Modules" src={'/images/svg/msync.svg'} className="sync-icon-img" onClick={() => onSyncModules(item.operatorId)} />}
                                          {!item.whiteLabel && <img title="Sync Version" src={'/images/svg/vsync.svg'} className="sync-icon-img" onClick={() => onSyncLicenceVersion(item.operatorId)} />}
                                          <img title="Assign Packages" src={"/images/svg/package-master.svg"} className="sync-icon-img" onClick={() => openPackagesListModal(item)} />
                                       </td>
                                    </tr>
                                 )
                              })}
                           </tbody>
                        </table>
                     </div>
                  </>

               )
            }
            ) : <></>}
         </div>

         <div className="login-popup">
            <Modal
               className="login licence-modules"
               show={licenseMasterAddModalShow}
               onHide={() => { closeLicenseMasterAddModal() }}
               backdrop="static"
               dialogAs={licenseMasterAddModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     {!!isEdit ? licenseCreationObj["operatorId"] + " / " + licenseCreationObj["companyName"] : "Add New License / WhiteLabel"}
                     <div className="btn-help d-inline-block float-right ">
                        {/* <i className="fa-question fa-solid font-size-16 mt-1"></i> */}
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div className="prl">
                     <div className="container-fluid">
                        <div className="row">
                           {/* LEFT PART START */}
                           <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                              <div className="d-flex">
                                 <div className="symbolrw-24 text-right font11 licence150">Whitelabel :</div>
                                 <div className="licence200">
                                    <div className="d-inline-block">
                                       <div className="form-check-inline mb-2 mr-4 width-25">
                                          <label className="form-check-label marginleft25group">
                                             <input type="radio" className="form-check-input mt-1" value={true} onChange={(e) => { onChange(e) }} name="whiteLabel" checked={!!licenseCreationObj && !!licenseCreationObj.whiteLabel} disabled={!isEdit ? false : true} />Yes
                                          </label>
                                       </div>
                                       <div className="form-check-inline width-25">
                                          <label className="form-check-label ml-3">
                                             <input type="radio" className="form-check-input mt-1" value={false} onChange={(e) => { onChange(e) }} name="whiteLabel" checked={!!licenseCreationObj && !licenseCreationObj.whiteLabel} disabled={!isEdit ? false : true} />No
                                          </label>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="d-flex">
                                 <div className="symbolrw-24 text-right font11 licence150">Operator Code :</div>
                                 <div className="licence200">
                                    {!isWhitelabel || !!isEdit ?
                                       <input type="text" name="operatorId" className="font11 h20 inputborder mb-2 ml-2 p-1 w-100" value={!!licenseCreationObj["operatorId"] ? licenseCreationObj["operatorId"] : ""} onChange={(e) => { onChange(e) }} disabled={!isEdit ? false : true} autoFocus />
                                       :
                                       <select title="operatorId" className="inputborder font11 w-100 mb-2 ml-2 h20 p-0" name="operatorId" value={!!licenseCreationObj["operatorId"] ? licenseCreationObj["operatorId"] : ""} onChange={(e) => { onChange(e) }} disabled={!isEdit ? false : true} autoFocus>
                                          <option value="">Select Operator</option>
                                          {!!operatorList && operatorList.length > 0 && operatorList.map((item, i) => {
                                             return (
                                                <option value={item.operatorId}>{item.operatorId + " - " + item.companyName}</option>
                                             )
                                          })}
                                       </select>
                                    }
                                 </div>
                              </div>
                              <div className="d-flex">
                                 <div className="symbolrw-24 text-right font11 licence150">Server Display Name :</div>
                                 <div className="licence200">
                                    <input type="text" name="serverDisplayName" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["serverDisplayName"] ? licenseCreationObj["serverDisplayName"] : ""} onChange={(e) => { onChange(e) }} autoFocus={isEdit && true} />
                                 </div>
                              </div>
                              <div className="d-flex">
                                 <div className="symbolrw-24 text-right font11 licence150">Primary Domain :</div>
                                 <div className={`licence200 ${errors.primaryDomainError && 'error'}`}>
                                    <input type="text" name="primaryDomain" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["primaryDomain"] ? licenseCreationObj["primaryDomain"] : ""} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, primaryDomainError: false }) : setErrors({ ...errors, primaryDomainError: true })) }} disabled={!isEdit ? false : true} />
                                 </div>
                              </div>
                              <div className="d-flex">
                                 <div className="symbolrw-24 text-right font11 licence150">Start Date :</div>
                                 <div className={`licence200 ${errors.licenseStartDateError && 'error'}`}>
                                    <input type="date" name="licenseStartDate" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["licenseStartDate"] ? licenseCreationObj["licenseStartDate"] : ""} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, licenseStartDateError: false }) : setErrors({ ...errors, licenseStartDateError: true })) }} />
                                 </div>
                              </div>
                              <div className="d-flex">
                                 <div className="licence150 d-inline-block symbolrw-24 text-right font11">End Date :</div>
                                 <div className={`licence200 d-inline-block symbolrw-25 ${errors.licenseEndDateError && 'error'}`}>
                                    <input type="date" name="licenseEndDate" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["licenseEndDate"] ? licenseCreationObj["licenseEndDate"] : ""} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, licenseEndDateError: false }) : setErrors({ ...errors, licenseEndDateError: true })) }} />
                                 </div>
                              </div>
                              <div className="d-flex">
                                 <div className="symbolrw-24 text-right font11 licence150">Description :</div>
                                 <div className="licence200">
                                    <input type="text" name="licenseDescription" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["licenseDescription"] ? licenseCreationObj["licenseDescription"] : ""} onChange={(e) => { onChange(e) }} />
                                 </div>
                              </div>
                              <div className="d-flex">
                                 {!isWhitelabel && <>
                                    <div className="licence150 d-inline-block symbolrw-24 text-right font11">Sharing :</div>
                                    <div className={`licence200 d-inline-block symbolrw-25 ${errors.licenseSharingError && 'error'}`}>
                                       <input type="number" name="licenseSharing" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["licenseSharing"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, licenseSharingError: false }) : setErrors({ ...errors, licenseSharingError: true })) }} disabled={(!isWhitelabel && !isEdit) ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </>}
                              </div>
                           </div>
                           {/* LEFT PART END */}
                           {/* RIGHT PART START */}
                           <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                              <div>&nbsp;</div>
                              <div className="d-flex">
                                 <div className="licence150 d-inline-block symbolrw-24 text-right font11">License Key :</div>
                                 <div className="licence200 d-inline-block symbolrw-25">
                                    <input type="text" name="licenseKey" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["licenseKey"] ? licenseCreationObj["licenseKey"] : ""} onChange={(e) => { onChange(e) }} disabled={true} />
                                 </div>
                              </div>
                              <div className="d-flex">
                                 {!isWhitelabel &&
                                    <>
                                       <div className="licence150 d-inline-block symbolrw-24 text-right font11">Server IP :</div>
                                       <div className="licence200 d-inline-block symbolrw-25">
                                          <input type="text" name="serverIP" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["serverIP"] ? licenseCreationObj["serverIP"] : ""} onChange={(e) => { onChange(e) }} />
                                       </div>
                                    </>}
                              </div>
                              <div className="d-flex">
                                 <div className="licence150 d-inline-block symbolrw-24 text-right font11">Secondary Domain :</div>
                                 <div className="licence200 d-inline-block symbolrw-25">
                                    <textarea rows={6} type="text" name="secondaryDomain" className="inputborder font11 w-100 mb-2 ml-2 " value={!!licenseCreationObj["secondaryDomain"] ? licenseCreationObj["secondaryDomain"] : ""} onChange={(e) => { onChange(e) }}>
                                    </textarea>
                                 </div>
                              </div>
                              <div className="licence150 d-inline-block symbolrw-24 text-right font11">Access Domain :</div>
                              <div className={`licence200 d-inline-block symbolrw-25 ${errors.licenseSharingError && 'error'}`}>
                                 <input type="text" name="accessDomain" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["accessDomain"]} onChange={(e) => { onChange(e) }} />
                              </div>
                           </div>
                           {/* RIGHT PART END */}
                        </div>


                        <div className="row">

                           {!isWhitelabel && <>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                                 <div className="d-flex">
                                    <div className="symbolrw-24 text-right font11 licence150">Symbols Limit :</div>
                                    <div className={`licence200 ${errors.symbolsLimitError && 'error'}`}>
                                       <input type="number" name="symbolsLimit" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["symbolsLimit"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, symbolsLimitError: false }) : setErrors({ ...errors, symbolsLimitError: true })) }} disabled={!isWhitelabel ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </div>
                                 <div className="d-flex">
                                    <div className="symbolrw-24 text-right font11 licence150">Dealers Limit :</div>
                                    <div className={`licence200 ${errors.dealersLimtError && 'error'}`}>
                                       <input type="number" name="dealersLimit" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["dealersLimit"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, dealersLimtError: false }) : setErrors({ ...errors, dealersLimtError: true })) }} disabled={!isWhitelabel ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </div>
                                 <div className="d-flex">
                                    <div className="symbolrw-24 text-right font11 licence150">Profiles Limit :</div>
                                    <div className={`licence200 ${errors.profilesLimitError && 'error'}`}>
                                       <input type="number" name="commissionProfileslimit" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["commissionProfileslimit"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, profilesLimitError: false }) : setErrors({ ...errors, profilesLimitError: true })) }} disabled={!isWhitelabel ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                                 <div className="d-flex">
                                    <div className="licence150 d-inline-block symbolrw-24 text-right font11">Groups Limit :</div>
                                    <div className={`licence200 d-inline-block symbolrw-25 ${errors.groupsLimitError && 'error'}`}>
                                       <input type="number" name="groupsLimit" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["groupsLimit"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, groupsLimitError: false }) : setErrors({ ...errors, groupsLimitError: true })) }} disabled={!isWhitelabel ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </div>
                                 <div className="d-flex">
                                    <div className="licence150 d-inline-block symbolrw-24 text-right font11">Clients Limit :</div>
                                    <div className={`licence200 d-inline-block symbolrw-25 ${errors.clientsLimitError && 'error'}`}>
                                       <input type="number" name="clientsLimit" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["clientsLimit"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, clientsLimitError: false }) : setErrors({ ...errors, clientsLimitError: true })) }} disabled={!isWhitelabel ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </div>
                                 <div className="d-flex">
                                    <div className="licence150 d-inline-block symbolrw-24 text-right font11">Balance Credit Amount :</div>
                                    <div className={`licence200 d-inline-block symbolrw-25 ${errors.balanceCreditLimitError && 'error'}`}>
                                       <input type="number" name="balanceCreditLimit" className="inputborder font11 w-100 mb-2 ml-2 h20" value={licenseCreationObj["balanceCreditLimit"]} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, balanceCreditLimitError: false }) : setErrors({ ...errors, balanceCreditLimitError: true })) }} disabled={!isWhitelabel ? false : true} onKeyDown={(e) => { restrictValueonType(e) }} />
                                    </div>
                                 </div>
                              </div>
                           </>}


                        </div>
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="d-flex feedmodule-width">
                                 <div className="symbolrw-24 text-right font11 licence150">Feed Module :</div>
                                 <div className="licencefeedmodule" >
                                    <Select
                                       options={feedModuleList}
                                       isMulti
                                       value={selectedFeedModuleId}
                                       onChange={setSelectedFeedModuleId}
                                       name="feedModuleId"
                                       className="react-source-box1 ml-2 "
                                       classNamePrefix="react-source1"
                                       isDisabled={!isWhitelabel ? false : true}
                                    />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <hr></hr>
                     {/* License Information START */}
                     <table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0" >
                        <tr>
                           <td className="text-highlight" colSpan={5}>{!!isWhitelabel ? "WhiteLabel" : "License"} Company Information</td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">Company Name :</td>
                           <td className={`licence200 ${errors.companyNameError && 'error'}`}>
                              <input type="text" name="companyName" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["companyName"] ? licenseCreationObj["companyName"] : ""} onChange={(e) => { onChange(e); (e.target.value !== '' ? setErrors({ ...errors, companyNameError: false }) : setErrors({ ...errors, companyNameError: true })) }} />
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td className="licence150 d-inline-block symbolrw-24 text-right font11">Person Name :</td>
                           <td className="licence200 d-inline-block symbolrw-25">
                              <input type="text" name="personName" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["personName"] ? licenseCreationObj["personName"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">Reference Name :</td>
                           <td className="licence200">
                              <input type="text" name="referenceName" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["referenceName"] ? licenseCreationObj["referenceName"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td className="licence150 d-inline-block symbolrw-24 text-right font11">Address :</td>
                           <td className="licence200 d-inline-block symbolrw-25">
                              <input type="text" name="companyAddress" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["companyAddress"] ? licenseCreationObj["companyAddress"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">City :</td>
                           <td className="licence200">
                              <input type="text" name="companyCity" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["companyCity"] ? licenseCreationObj["companyCity"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td className="licence150 d-inline-block symbolrw-24 text-right font11">State :</td>
                           <td className="licence200 d-inline-block symbolrw-25">
                              <input type="text" name="companyState" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["companyState"] ? licenseCreationObj["companyState"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">ContactNo :</td>
                           <td className="licence200">
                              <input type="text" name="contactNo" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["contactNo"] ? licenseCreationObj["contactNo"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td className="licence150 d-inline-block symbolrw-24 text-right font11">Email Id :</td>
                           <td className="licence200 d-inline-block symbolrw-25">
                              <input type="text" name="contactEmail" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["contactEmail"] ? licenseCreationObj["contactEmail"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">Website :</td>
                           <td className="licence200">
                              <input type="text" name="webSite" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["webSite"] ? licenseCreationObj["webSite"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td className="licence150 d-inline-block symbolrw-24 text-right font11">SkypeId :</td>
                           <td className="licence200 d-inline-block symbolrw-25">
                              <input type="text" name="contactSkype" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["contactSkype"] ? licenseCreationObj["contactSkype"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">Company Desc :</td>
                           <td className="licence200">
                              <input type="text" name="companyDescription" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["companyDescription"] ? licenseCreationObj["companyDescription"] : ""} onChange={(e) => { onChange(e) }} />
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td className="licence150 d-inline-block symbolrw-24 text-right font11">License Status :</td>
                           <td className="licence200 d-inline-block symbolrw-25">
                              <div className="d-inline-block">
                                 <div className="form-check-inline mb-2 mr-4 width-25">
                                    <label className="form-check-label marginleft25group">
                                       <input type="radio" className="form-check-input mt-1" value={true} name="licenseStatus" onChange={(e) => { onChange(e) }} checked={!!licenseCreationObj && licenseCreationObj.licenseStatus} />Yes
                                    </label>
                                 </div>
                                 <div className="form-check-inline width-25">
                                    <label className="form-check-label ml-3">
                                       <input type="radio" className="form-check-input mt-1" value={false} name="licenseStatus" onChange={(e) => { onChange(e) }} checked={!!licenseCreationObj && !licenseCreationObj.licenseStatus} />No
                                    </label>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td className="symbolrw-24 text-right font11 licence150">
                              <div className="imgpreview">
                                 <img alt="" src={!!licenseCreationObj["licenseLogo"] ? licenseCreationObj["licenseLogo"] : ""} />
                              </div>
                           </td>
                           <td className="licence200">
                              <div className="form-group d-inline-block ml-2">
                                 <label htmlFor="licenseLogo" className="form-label">Company Logo :</label>
                                 <input type="file" className="form-control" name="licenseLogo" id="licenseLogo" onChange={(e) => { onImageChoose(e) }} accept="image/*" />
                              </div>
                           </td>
                           <td className="licence50" >&nbsp;</td>
                           <td colSpan={2}>
                              <div>
                                 <td className="licence150 d-inline-block symbolrw-24 text-right font11">Client Web :</td>
                                 <td className="licence200 d-inline-block symbolrw-25">
                                    <div className="d-inline-block">
                                       <div className="form-check-inline mb-2 mr-4 width-25">
                                          <label className="form-check-label marginleft25group">
                                             <input type="radio" className="form-check-input mt-1" value={true} name="allowedClientWeb" onChange={(e) => { onChange(e) }} checked={licenseCreationObj.allowedClientWeb} />Yes
                                          </label>
                                       </div>
                                       <div className="form-check-inline width-25">
                                          <label className="form-check-label ml-3">
                                             <input type="radio" className="form-check-input mt-1" value={false} name="allowedClientWeb" onChange={(e) => { onChange(e) }} checked={!licenseCreationObj.allowedClientWeb} />No
                                          </label>
                                       </div>
                                    </div>
                                 </td>
                              </div>
                              <div>
                                 <td className="licence150 d-inline-block symbolrw-24 text-right font11">Online Payment :</td>
                                 <td className="licence200 d-inline-block symbolrw-25">
                                    <div className="d-inline-block">
                                       <div className="form-check-inline mb-2 mr-4 width-25">
                                          <label className="form-check-label marginleft25group">
                                             <input type="radio" className="form-check-input mt-1" value={true} name="allowedOnlinePayment" onChange={(e) => { onChange(e) }} checked={licenseCreationObj.allowedOnlinePayment} />Yes
                                          </label>
                                       </div>
                                       <div className="form-check-inline width-25">
                                          <label className="form-check-label ml-3">
                                             <input type="radio" className="form-check-input mt-1" value={false} name="allowedOnlinePayment" onChange={(e) => { onChange(e) }} checked={!licenseCreationObj.allowedOnlinePayment} />No
                                          </label>
                                       </div>
                                    </div>
                                 </td>
                              </div>
                              <div>
                                 <td className="licence150 d-inline-block symbolrw-24 text-right font11">Licence Type :</td>
                                 <td className="licence200 d-inline-block symbolrw-25">
                                    <div className="d-inline-block">
                                       <div className="form-check-inline mb-2 mr-4 width-25">
                                          <label className="form-check-label marginleft25group">
                                             <input type="radio" className="form-check-input mt-1" value="B2B" name="licenseType" onChange={(e) => { onChange(e) }} checked={licenseCreationObj.licenseType === "B2B"} />B2B
                                          </label>
                                       </div>
                                       <div className="form-check-inline width-25">
                                          <label className="form-check-label ml-3">
                                             <input type="radio" className="form-check-input mt-1" value="B2C" name="licenseType" onChange={(e) => { onChange(e) }} checked={licenseCreationObj.licenseType === "B2C"} />B2C
                                          </label>
                                       </div>
                                    </div>
                                 </td>
                              </div>
                              <div>
                                 {(!!licenseCreationObj.allowedClientWeb && licenseCreationObj.allowedClientWeb && isEdit) ?
                                    <>
                                       <td colSpan={2}></td>
                                       <td className="licence150 d-inline-block symbolrw-24 text-right font11">Auth Key :</td>
                                       <td className="licence200 d-inline-block symbolrw-25">
                                          <input
                                             className="font11 h20 inputborder mb-2 ml-2 p-1"
                                             disabled
                                             name="authKey"
                                             value={licenseCreationObj?.authKey}
                                          />

                                          <span><i className="fa-solid fa-copy margin-20" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => copyToClipboard(licenseCreationObj?.authKey)}></i></span>
                                       </td>
                                    </>
                                    :
                                    <td colSpan={2}></td>
                                 }
                              </div>
                           </td>
                        </tr>
                     </table>
                     <hr></hr>
                     {/* License Information END */}
                     {/* License Admin User Details START */}
                     {(!isWhitelabel && !isEdit) &&
                        <table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0" >
                           <tr>
                              <td className="text-highlight" colSpan={5}>Licence Admin User Details</td>
                           </tr>
                           <tr>
                              <td className="symbolrw-24 text-right font11 licence150">UserName / LoginId :</td>
                              <td className="licence200">
                                 <input type="text" name="userName" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["userName"] ? licenseCreationObj["userName"] : ""} onChange={(e) => { onChange(e) }} disabled={!isWhitelabel ? false : true} />
                              </td>
                              <td className="licence50" >&nbsp;</td>
                              <td className="licence150 d-inline-block symbolrw-24 text-right font11">Name :</td>
                              <td className="licence200 d-inline-block symbolrw-25">
                                 <input type="text" name="name" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["name"] ? licenseCreationObj["name"] : ""} onChange={(e) => { onChange(e) }} disabled={!isWhitelabel ? false : true} />
                              </td>
                           </tr>
                           <tr>
                              <td className="symbolrw-24 text-right font11 licence150">User Role :</td>
                              <td className="licence200">
                                 <input type="text" name="userRole" className="inputborder font11 w-100 mb-2 ml-2 h20" value="Admin" disabled={true} />
                              </td>
                              <td className="licence50" >&nbsp;</td>
                              <td className="licence150 d-inline-block symbolrw-24 text-right font11">User Password :</td>
                              <td className="licence200 d-inline-block symbolrw-25">
                                 <input type="text" name="userPassword" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["userPassword"] ? licenseCreationObj["userPassword"] : ""} onChange={(e) => { onChange(e) }} disabled={!isWhitelabel ? false : true} />
                              </td>
                           </tr>
                           <tr>
                              <td className="symbolrw-24 text-right font11 licence150">User Description :</td>
                              <td className="licence200">
                                 <input type="text" name="userDescription" className="inputborder font11 w-100 mb-2 ml-2 h20" value={!!licenseCreationObj["userDescription"] ? licenseCreationObj["userDescription"] : ""} onChange={(e) => { onChange(e) }} disabled={!isWhitelabel ? false : true} />
                              </td>
                              <td className="licence50" >&nbsp;</td>
                              <td className="licence150 d-inline-block symbolrw-24 text-right font11">User Status :</td>
                              <td className="licence200 d-inline-block symbolrw-25">
                                 <div className="d-inline-block">
                                    <div className="form-check-inline mb-2 mr-4 width-25">
                                       <label className="form-check-label marginleft25group">
                                          <input type="radio" className="form-check-input mt-1" value={true} name="userStatus" onChange={(e) => { onChange(e) }} checked={!!licenseCreationObj && !!licenseCreationObj.userStatus} disabled={!isWhitelabel ? false : true} />Yes
                                       </label>
                                    </div>
                                    <div className="form-check-inline width-25">
                                       <label className="form-check-label ml-3">
                                          <input type="radio" className="form-check-input mt-1" value={false} name="userStatus" onChange={(e) => { onChange(e) }} checked={!!licenseCreationObj && !licenseCreationObj.userStatus} disabled={!isWhitelabel ? false : true} />No
                                       </label>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </table>
                     }
                     {/* License Admin User Details END */}
                  </div>

               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        {isEdit &&
                           <Button className="btnmain mr-3" onClick={() => { statusOfTestConnection() }}>
                              Test Connection
                           </Button>}
                        <Button className="btnmain mr-3" onClick={() => { onSubmitLicense() }} disabled={disableSubmitBtn}>
                           {disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>} {!!isEdit ? "Update" : "Submit"}
                        </Button>
                        <Button onClick={() => { closeLicenseMasterAddModal() }} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
         <div className="login-popup">
            <Modal
               className="login feed-modules"
               show={userUpdateModalShow}
               onHide={() => { closeUserUpdateModalShow() }}
               backdrop="static"
               dialogAs={userUpdateModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     {!!isEdit ? licenseCreationObj["operatorId"] + " / " + licenseCreationObj["companyName"] : " Update User"}
                     <div className="btn-help d-inline-block float-right ">
                        {/* <i className="fa-question fa-solid font-size-16 mt-1"></i> */}
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div className="fidderbox-inner office-feed-height">
                     <div>
                        <table border="0" cellSpacing="0" cellPadding="0" className="w-100">
                           <tbody>
                              <tr>
                                 <td className="update-user-width font11 text-right font11 v-align-baseline">Admin User Status:</td>
                                 <td className="feederw-430 loginUser ">
                                    <label className=" font11 w-100 mb-1 ml-2 h20 label-mt-5"> {!!userDetailObj && Object.keys(userDetailObj).length > 0 ? userDetailObj.userStatusDefault ? "Active" : "Inactive" : "---"} </label>
                                 </td>
                                 <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                              </tr>
                              <tr>
                                 <td className="update-user-width font11 text-right font11 v-align-baseline">Reset Admin User Password:</td>
                                 <td className="feederw-430 loginUser ">
                                    <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" maxLength="50" name="userPassword" value={!!userDetailObj && Object.keys(userDetailObj).length > 0 ? userDetailObj.userPassword : ""} onChange={(e) => { onChangeUserDetail(e) }} />
                                 </td>
                                 <td className="feederw-100 font11 text-right font11">
                                    <button className="mb-0 ml-3 btn-small" onClick={() => { onUpdateUserDetail("userPassword") }}>Submit</button>
                                 </td>
                              </tr>
                              <tr>
                                 <td className="update-user-width font11 text-right font11 v-align-baseline">Admin User Status:</td>
                                 <td className="symbolrw-430 officeuser-redio-feed">
                                    <div className="form-check-inline width-50 mb-2 mr-4">
                                       <label className="form-check-label marginleft25group">
                                          <input type="radio" className="form-check-input mt-1" name="userStatus" value={true} onChange={(e) => { onChangeUserDetail(e) }} checked={!!userDetailObj && Object.keys(userDetailObj).length > 0 ? !!userDetailObj.userStatus : ""} />Active
                                       </label>
                                    </div>
                                    <div className="form-check-inline width-50">
                                       <label className="form-check-label ml-3">
                                          <input type="radio" className="form-check-input mt-1" name="userStatus" value={false} onChange={(e) => { onChangeUserDetail(e) }} checked={!!userDetailObj && Object.keys(userDetailObj).length > 0 ? !userDetailObj.userStatus : ""} />Inactive
                                       </label>
                                    </div>
                                 </td>
                                 <td className="feederw-100 font11 text-right font11">
                                    <button className="mb-0 ml-3 btn-small" onClick={() => { onUpdateUserDetail("userStatus") }}>Submit</button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        {/* <Button className="btnmain mr-3" onClick={() => {  }}>
                           {!!isEdit ? "Update" : "Submit"}
                        </Button> */}
                        <Button onClick={() => { closeUserUpdateModalShow() }} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>

         <div className="login-popup">
            <Modal
               className="login feed-modules"
               show={showPackagesListModal}
               onHide={() => { closePackageListModal() }}
               backdrop="static"
               dialogAs={packageListModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     Packages List
                     <div className="btn-help d-inline-block float-right ">
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div className="fidderbox-inner office-feed-height packageslist">
                     <div>
                        <div className="container-fluid">
                           <div className="row">
                              <div className="col-12 col-lg-12 col-md-12 col-sm-12 font-13 font-bold mb-2">Select Packages:</div>
                           </div>
                           <div className="row">
                              {(!!packagesList && packagesList.length > 0) ? packagesList?.sort()?.map((item, index) => {
                                 return (
                                    <div key={`packages_${item.packageId}`} className='col-12 col-sm-12 col-md-6 col-lg-6 mb-2'>
                                       <div className=''>
                                          <div>
                                             <input
                                                id=""
                                                className="form-check-input mr-2 one-click-margin2"
                                                type="checkbox"
                                                name={selectedPackagesIds}
                                                checked={selectedPackagesIds.includes(item.packageId)}
                                                onChange={(e) => selectedOnChangeFn(e.target.checked, item.packageId)} />
                                             {item.packageName}
                                          </div>
                                       </div>
                                    </div>
                                 )
                              })
                                 : <NoDataError />
                              }
                           </div>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        <Button className="btnmain mr-3" onClick={() => { onSubmitPackagesList() }} disabled={packageDisableSubmitBtn}>
                           {packageDisableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>} Submit
                        </Button>
                        <Button onClick={() => { closePackageListModal() }} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
      </>
   );

}
export default LicenceMaster;
